import { gql } from "@apollo/client/core";

export const getManyProjectsByUserID = gql`
  query GetManyProjectsByUserID(
    $userId: String!
    $filter: GetManyProjectsByUserIDRequestFilterInput
    $paginationArguments: PaginationArgumentsInput
  ) {
    GetManyProjectsByUserID(input: { filter: $filter, paginationArguments: $paginationArguments, userId: $userId }) {
      connection {
        edges {
          node {
            alias
            createdAt
            description
            logoAssetUrl
            name
            projectId
            updatedAt
            organizationId
            groupId
            roleByUser {
              title
            }
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
      }
    }
  }
`;
